import { render, staticRenderFns } from "./SalaryBanks.vue?vue&type=template&id=923e8a94&scoped=true"
import script from "./SalaryBanks.vue?vue&type=script&lang=js"
export * from "./SalaryBanks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923e8a94",
  null
  
)

export default component.exports